import { useEffect, useRef, useState } from "react";
import AppConfig from "./AppConfig.json";
import axios from "axios";
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import * as actions from "./actions";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ErrorMessage from "./ErrorMessage";
import PinInput from "react-pin-input";

export function MemberEditMobile(props) {
  let { app, onUpdate } = props;
  const { currentUserProfile } = app;
  const history = useHistory();
  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileCountryCode, setMobileCountryCode] = useState("66");
  const [errorMessage, setErrorMessage] = useState(null);
  const [verifyOTP, setVerifyOTP] = useState(false);
  const [otpRequestID, setOtpRequestID] = useState(true);
  let [isMismatch, setIsMismatch] = useState(false);
  let pinInput = useRef();

  useEffect(() => {
    setMobileCountryCode(currentUserProfile.mobileCountryCode);
    setMobileNumber(currentUserProfile.mobileNumber);
    const interval = setInterval(() => {
      setVerifyOTP((verifyOTP) => (verifyOTP > 0 ? verifyOTP - 1 : verifyOTP));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const formValidate = () => {
    const re = /0[0-9]{9}/;
    return mobileNumber && re.test(mobileNumber);
  };

  const validateOTP = async (pin) => {
    try {
      let result = await axios.post(
        `${AppConfig.endpoint}/member/otp/verify`,
        { code: pin, otpRequestID },
        {
          headers: {
            "x-access-token": app.accessToken,
            "x-api-key": AppConfig.api_key,
          },
        }
      );
      if (!result.error) {
        if (result.data && result.data.isVerified) {
          sendUpdate();
        } else {
          setIsMismatch(true);
        }
      }
    } catch (err) {
      // history.push("/member/error")
      // setIsMismatch(true)
    }
  };

  const requestOtp = async () => {
    try {
      let result = await axios.post(
        `${AppConfig.endpoint}/member/otp/request`,
        {
          type: "mobile",
          on: {
            country: mobileCountryCode,
            value: mobileNumber,
          },
        },
        {
          headers: {
            "x-access-token": props.app.accessToken,
            "x-api-key": AppConfig.api_key,
          },
        }
      );

      if (!result.error) {
        setOtpRequestID(result.data.requestID);
        setVerifyOTP(299); // Timeout 5 min.( 300 sec.)
      }
    } catch (err) {
      // history.push("/member/error")
      // setIsMismatch(true)
    }
  };

  const sendUpdate = async () => {
    let body = { mobile: mobileNumber, mobileCountry: mobileCountryCode };

    let result = await axios.post(
      `${AppConfig.endpoint}/member/update/mobile`,
      body,
      {
        headers: {
          "x-access-token": app.accessToken,
          "x-api-key": AppConfig.api_key,
        },
      }
    );

    if (result.data.success) {
      onUpdate && onUpdate();
      history.push("/member/profile");
    } else {
      setErrorMessage(result.data);
    }
  };

  return (
    <div className="edit-screen pin-auth-screen">
      {errorMessage && <ErrorMessage title="Error" message={errorMessage} />}
      {verifyOTP === false && (
        <>
          <div class="section-header">Mobile</div>
          <div className="edit-form">
            <PhoneInput
              country={mobileCountryCode}
              disableCountryCode={true}
              value={mobileNumber}
              autoFormat={false}
              renderFlagAsDial={true}
              specialLabel={<label className="label">Mobile Number</label>}
              onChange={(mobileNumber, country) => {
                setMobileNumber(mobileNumber);
                setMobileCountryCode(country.dialCode);
              }}
            />
            {/* <div className="field">
                    <label className="label">Mobile Number</label>
                    <div className="control">
                        <input className="input" type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                </div> */}
          </div>

          <div className="screen-footer">
            <button
              className="button is-fullwidth is-save"
              disabled={!formValidate()}
              onClick={() => requestOtp()}
            >
              Continue
            </button>
          </div>
        </>
      )}
      {verifyOTP !== false && (
        <>
          <div style={{ marginBottom: 20 }}>Enter OTP</div>
          <div className="hint" style={{ background: "none", color: "#888" }}>
            Enter OTP sent to your mobile number *******
            {mobileNumber.slice(mobileNumber.length - 4)}
          </div>

          <PinInput
            ref={pinInput}
            length={6}
            initialValue=""
            secret={false}
            onChange={(value, index) => {}}
            type="numeric"
            inputMode="number"
            style={{ borderRadius: 8 }}
            inputStyle={{
              height: 48,
              width: 40,
              borderRadius: 8,
              background: "#252525",
              border: 0,
              margin: 4,
              fontSize: 25,
              color: "#FFFFFF",
            }}
            inputFocusStyle={{ background: "#383838", border: 0 }}
            onComplete={(value, index) => {
              validateOTP(value);
              pinInput.current.clear();
            }}
            autoSelect={true}
            regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
          />

          {verifyOTP > 0 && (
            <div className="hint" style={{ background: "none", color: "#888" }}>
              Resend OTP code if it doesn’t arrive in{" "}
              {Math.floor(verifyOTP / 60)}:
              {verifyOTP % 60 > 9 ? verifyOTP % 60 : `0${verifyOTP % 60}`}
            </div>
          )}

          {isMismatch && (
            <div className="help has-text-danger">
              Incorrect OTP. Please try again.
            </div>
          )}
          {verifyOTP <= 0 && (
            <div className="screen-footer">
              <button
                className="button is-fullwidth is-save"
                onClick={() => requestOtp()}
              >
                Resend OTP
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default withRouter(connect((state) => state, actions)(MemberEditMobile));
